import { render } from "./LatestBlogPage.vue?vue&type=template&id=22acd523&scoped=true"
import script from "./LatestBlogPage.vue?vue&type=script&lang=js"
export * from "./LatestBlogPage.vue?vue&type=script&lang=js"

import "./LatestBlogPage.vue?vue&type=style&index=0&id=22acd523&scoped=true&lang=css"
import "./LatestBlogPage.vue?vue&type=style&index=1&id=22acd523&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22acd523"]])

export default __exports__